<template>
	<div>
		<div class="d-flex justify-space-between align-center mb-2 mt-6">
			<div class="input-wrap">
				<h5 class="mb-2">Ventas por cobrar</h5>
			</div>
			<div class="action-btn-wrap">
				<v-btn color="accent" class="mr-2" @click.prevent="updateData()">
					<v-icon left light small>mdi-reload</v-icon>
					Actualizar
				</v-btn>
			</div>
		</div>
		<v-card color="secondary" class="pa-3">
			<v-row dense>
				<v-col cols="12" xl="3" lg="3" md="3" sm="12">
					<div class="form-group">
						<label for="">Salón</label>
						<el-select
							v-model="search.salon_id"
							@change="getRecords()"
							filterable
							clearable
						>
							<el-option
								v-for="option in salons"
								:key="option.id"
								:value="option.id"
								:label="option.name"
							></el-option>
						</el-select>
					</div>
				</v-col>
				<v-col cols="12" xl="3" lg="3" md="3" sm="12">
					<div class="form-group">
						<label for="">Mesa</label>
						<el-select
							v-model="search.table_id"
							@change="getRecords()"
							filterable
							clearable
						>
							<el-option
								v-for="option in tables"
								:key="option.id"
								:value="option.id"
								:label="option.name"
							></el-option>
						</el-select>
					</div>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="2" sm="12">
					<div class="form-group">
						<label for="">Mozo</label>
						<el-select
							v-model="search.waiter_id"
							@change="getRecords()"
							filterable
							clearable
						>
							<el-option
								v-for="option in waiters"
								:key="option.id"
								:value="option.id"
								:label="option.name"
							></el-option>
						</el-select>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col xl="12" lg="12" md="12" sm="12">

					<div class="table-responsive">
						<v-simple-table>
							<thead>
							<tr>
								<th width="5%" class="text-right">N°</th>
								<th class="text-center">NÚMERO</th>
								<!-- <th>FECHA</th> -->
								<th>HORA</th>
								<th>MOZO</th>
								<th class="text-right">MESA</th>
								<!-- <th>CLEINTE</th> -->
								<th class="text-right">TOTAL</th>
								<th class="text-right">ACCIONES</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(row, index) in records" :key="index">
								<td class="text-right">{{ index + 1 }}</td>
								<td class="text-center">
									<h5 class="pb-0 success--text">{{ row.identifier }}</h5>
								</td>
								<!-- <td>{{ row.date_of_issue }}</td> -->
								<td>{{ row.time_of_issue }}</td>
								<td><strong class="info--text">{{ row.waiter }}</strong></td>
								<td class="text-right" >
									<h5 class="pb-0 warning--text">{{ row.tble }}</h5>
								</td>
								<!-- <td>
								  {{ row.customer }}
								</td> -->
								<td class="text-right">
									<h5 class="pb-0 success--text">S/ {{ row.total }}</h5>
								</td>

								<td class="text-right mr-0 ml-0 pl-0 pr-0">
									<v-btn
										color="accent"
										class="ma-1"
										fab
										dark
										:to="{ name: 'SaleReceivable', params: { id: row.id } }"
									>
										<v-icon>mdi-exit-to-app</v-icon>
									</v-btn>
								</td>
							</tr>
							</tbody>
						</v-simple-table>
						<div>
							<v-pagination
								@next="getRecords"
								@previous="getRecords"
								@input="getRecords"
								:length="pagination.last_page"
								:total-visible="7"
								v-model="pagination.current_page"
								circle
								prev-icon="mdi-chevron-left"
								next-icon="mdi-chevron-right"
							></v-pagination>
						</div>
					</div>
				</v-col>
			</v-row>
		</v-card>
	</div>
</template>

<script>

import queryString from 'query-string';

export default {
	data() {
		return {
			showDialog: false,
			resource: 'sales-receivables',
			recordId: null,
			records: [],
			tab: null,
			intervalID: '',
			pagination: {},
			search: {
				salon_id: null,
				table_id: null,
				waiter_id: null,
				number: null,
			},
			salons: [],
			tables: [],
			waiters: [],
			echoServer: window.Echo,
			ordersChannel: null,
			flashButtonLoading: false,
			curreentIndex: null,
		};
	},
	mounted: function() {
		this.ordersChannel = this.echoServer.private('sales-receivables');
		this.ordersChannel.listen('getSalesReceivables', this.handleOrdersEvent)
	},
	beforeDestroy() {
		if (this.ordersChannel) {
			this.ordersChannel.stopListening('getSalesReceivables', this.handleOrdersEvent);
		}
	},
	created() {
		this.getFilters();
		this.getRecords();
	},
	methods: {
		handleOrdersEvent() {
			this.getRecords()
		},
		getFilters() {
			this.$http.get(`/${this.resource}/filters`).then((response) => {
				this.salons = response.data.salons;
				this.tables = response.data.tables;
				this.waiters = response.data.waiters;
			});
		},
		updateData() {
			// this.$eventHub.$emit('reloadData', this.resource)
			location.reload();
		},
		getRecords() {
			return this.$http.get(`/${this.resource}/records?${this.getQueryParameters()}`).then((response) => {
				this.records = response.data.data
				this.pagination = response.data.meta
				this.pagination.per_page = parseInt(response.data.meta.per_page)
			});
		},
		getQueryParameters() {
			return queryString.stringify({
				page: this.pagination.current_page,
				limit: this.limit,
				...this.search
			})
		},
		async flashPay(id, index) {
			this.flashButtonLoading = true;
			this.curreentIndex = index
			await this.$http.get(`/${this.resource}/pay/${id}`).then(() => {
				this.getRecords();

				this.flashButtonLoading = false;
				this.curreentIndex = null;
			});
		},
		clickCancelCommand(id) {
			return new Promise((resolve) => {
				this.$alert('¿Desea cancelar el pedido?', 'Cancelar', {
					confirmButtonText: 'Cancelar pedido',
					cancelButtonText: 'Cerrar',
					type: 'warning'
				}).then(() => {
					this.$http.delete(`/commands/cancelled/${id}`)
						.then(resp => {
							if (resp.data.success) {
								this.$message.success('El pedido fue cancelado satisfactoriamente');
							} else {
								this.$message.error(resp.data.message);
							}

							resolve();
						})
						.catch(error => {
							if (error.response.status === 500) {
								this.$message.error('Error al intentar cancelar el pedido.');
							} else if(error.response.status === 403) {
								this.$message.error('No posee permisos para realizar esta acción.');
							} else {
								console.log(error.response.data.message)
							}
						})
				}).catch(error => {
					console.log(error)
				});
			})
		},
	},
};
</script>
